import {
  getFailActionName,
  getStartActionName,
  getSuccessActionName,
} from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import { combineReducers } from "redux";
import {
  HighlightData,
  HIGHLIGHTS_SET_FILTER,
  HighlightsAction,
  HighlightsFilter,
  HighlightsFilterType,
  HighlightsState,
} from "./types";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import TopLevelMethod from "../../core/TopLevelMethod";

const subscribedHighlightsRawData = (state = [], action) => {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.GET_HIGHLIGHTS):
      return action.resultData.subscribedHighlights || [];
    default:
      return state;
  }
};

const highlightsRawData = (state: HighlightData[] = [], action) => {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.GET_HIGHLIGHTS):
      return action.resultData.highlights;
    case getStartActionName(ViewerMethod.DELETE_HIGHLIGHT):
      return state.filter(
        (highlight) => highlight.syncId !== action.apiCallArgs[0]?.syncId
      );
    case getStartActionName(ViewerMethod.UPDATE_HIGHLIGHT):
      return state.map((highlight) => {
        const note = action.apiCallArgs[0]?.dataFields.noteText;
        const marker = action.apiCallArgs[0]?.dataFields.markerId;
        // does not account for marker updates -- waits for mosaic response
        return !marker && highlight.syncId === action.apiCallArgs[0]?.syncId
          ? {
              ...highlight,
              noteText: note,
              hasNote: !!note,
            }
          : highlight;
      });
    case getSuccessActionName(ViewerMethod.UPDATE_HIGHLIGHT):
      return state.map((highlight) => {
        return highlight.syncId === action.apiCallArgs[0]?.syncId
          ? action.resultData
          : highlight;
      });
    case getSuccessActionName(ViewerMethod.HIGHLIGHT_CURRENT_SELECTION):
      return [...state, action.resultData];
    case getStartActionName(TopLevelMethod.DELETE_MARKER):
      const deletedMarkerId = action.apiCallArgs[0];
      return state.filter(
        (highlight) => highlight.markerId !== deletedMarkerId
      );
    case getSuccessActionName(TopLevelMethod.UPDATE_MARKER):
      return state.map((highlight) => {
        if (highlight.markerId === action.apiCallArgs[0]) {
          return {
            ...highlight,
            vstColor: action.resultData.vstColor,
            vstColorDark: action.resultData.vstColorDark,
          };
        }
        return highlight;
      });
    default:
      return state;
  }
};

const loadStatus = (
  state: DetailedLoadStatus = DetailedLoadStatus.WAITING,
  action
) => {
  switch (action.type) {
    case getStartActionName(ViewerMethod.GET_HIGHLIGHTS):
      return DetailedLoadStatus.FETCHING;
    case getSuccessActionName(ViewerMethod.GET_HIGHLIGHTS):
      return DetailedLoadStatus.OK;
    case getFailActionName(ViewerMethod.GET_HIGHLIGHTS):
      return DetailedLoadStatus.ERROR;
    default:
      return state;
  }
};

const highlightsFilter = (
  state: HighlightsFilter = { type: HighlightsFilterType.None },
  action: HighlightsAction
): HighlightsFilter => {
  switch (action.type) {
    case HIGHLIGHTS_SET_FILTER:
      return action.filter;
    default:
      return state;
  }
};

export default combineReducers<HighlightsState>({
  subscribedHighlightsRawData,
  highlightsRawData,
  loadStatus,
  highlightsFilter,
});
